export const CREATE_RESERVE_ENTITY = 'CREATE_RESERVE_ENTITY'
export const UPDATE_RESERVE_ENTITY = 'UPDATE_RESERVE_ENTITY'
export const DELETE_RESERVE_ENTITY = 'DELETE_RESERVE_ENTITY'

export const BATCH_CREATE_RESERVE_ENTITY = 'BATCH_CREATE_RESERVE_ENTITY'